/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState, useRef } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import SavAddress from './pages/SavAddress';
import { showToast } from '../showTost';
import Search from './pages/Search';
import { useTranslation } from 'react-i18next';
import LocationImg from "../Image/permission.png";
import * as turf from '@turf/turf';
import Logo from "../Image/logoheader.png";
import FooterLogo from "../Image/logofooter.png";
import OneSignal from 'react-onesignal';

const Header = () => {

    const { t, i18n } = useTranslation();
    const { BaseUrl, MapKey, isshowadsbox, oneSignalAppId, setIsShowAdsBox, AddressRef, setIsChangeLocation, isInstallable, setIsInstallable, catlist, islogin } = useContext(MyContext);

    const MenuList = [{
        title: "My Booking", path: "/bookings", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.74999V2C8.74999 1.59 8.40999 1.25 7.99999 1.25C7.58999 1.25 7.24999 1.59 7.24999 2V3.56C4.54999 3.81 3.23999 5.42 3.03999 7.81C3.01999 8.1 3.25999 8.34 3.53999 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z" fill="#080B30" />
            <path d="M20 9.83984H4C3.45 9.83984 3 10.2898 3 10.8398V16.9998C3 19.9998 4.5 21.9998 8 21.9998H16C19.5 21.9998 21 19.9998 21 16.9998V10.8398C21 10.2898 20.55 9.83984 20 9.83984ZM9.21 18.2098C9.16 18.2498 9.11 18.2998 9.06 18.3298C9 18.3698 8.94 18.3998 8.88 18.4198C8.82 18.4498 8.76 18.4698 8.7 18.4798C8.63 18.4898 8.57 18.4998 8.5 18.4998C8.37 18.4998 8.24 18.4698 8.12 18.4198C7.99 18.3698 7.89 18.2998 7.79 18.2098C7.61 18.0198 7.5 17.7598 7.5 17.4998C7.5 17.2398 7.61 16.9798 7.79 16.7898C7.89 16.6998 7.99 16.6298 8.12 16.5798C8.3 16.4998 8.5 16.4798 8.7 16.5198C8.76 16.5298 8.82 16.5498 8.88 16.5798C8.94 16.5998 9 16.6298 9.06 16.6698C9.11 16.7098 9.16 16.7498 9.21 16.7898C9.39 16.9798 9.5 17.2398 9.5 17.4998C9.5 17.7598 9.39 18.0198 9.21 18.2098ZM9.21 14.7098C9.02 14.8898 8.76 14.9998 8.5 14.9998C8.24 14.9998 7.98 14.8898 7.79 14.7098C7.61 14.5198 7.5 14.2598 7.5 13.9998C7.5 13.7398 7.61 13.4798 7.79 13.2898C8.07 13.0098 8.51 12.9198 8.88 13.0798C9.01 13.1298 9.12 13.1998 9.21 13.2898C9.39 13.4798 9.5 13.7398 9.5 13.9998C9.5 14.2598 9.39 14.5198 9.21 14.7098ZM12.71 18.2098C12.52 18.3898 12.26 18.4998 12 18.4998C11.74 18.4998 11.48 18.3898 11.29 18.2098C11.11 18.0198 11 17.7598 11 17.4998C11 17.2398 11.11 16.9798 11.29 16.7898C11.66 16.4198 12.34 16.4198 12.71 16.7898C12.89 16.9798 13 17.2398 13 17.4998C13 17.7598 12.89 18.0198 12.71 18.2098ZM12.71 14.7098C12.66 14.7498 12.61 14.7898 12.56 14.8298C12.5 14.8698 12.44 14.8998 12.38 14.9198C12.32 14.9498 12.26 14.9698 12.2 14.9798C12.13 14.9898 12.07 14.9998 12 14.9998C11.74 14.9998 11.48 14.8898 11.29 14.7098C11.11 14.5198 11 14.2598 11 13.9998C11 13.7398 11.11 13.4798 11.29 13.2898C11.38 13.1998 11.49 13.1298 11.62 13.0798C11.99 12.9198 12.43 13.0098 12.71 13.2898C12.89 13.4798 13 13.7398 13 13.9998C13 14.2598 12.89 14.5198 12.71 14.7098ZM16.21 18.2098C16.02 18.3898 15.76 18.4998 15.5 18.4998C15.24 18.4998 14.98 18.3898 14.79 18.2098C14.61 18.0198 14.5 17.7598 14.5 17.4998C14.5 17.2398 14.61 16.9798 14.79 16.7898C15.16 16.4198 15.84 16.4198 16.21 16.7898C16.39 16.9798 16.5 17.2398 16.5 17.4998C16.5 17.7598 16.39 18.0198 16.21 18.2098ZM16.21 14.7098C16.16 14.7498 16.11 14.7898 16.06 14.8298C16 14.8698 15.94 14.8998 15.88 14.9198C15.82 14.9498 15.76 14.9698 15.7 14.9798C15.63 14.9898 15.56 14.9998 15.5 14.9998C15.24 14.9998 14.98 14.8898 14.79 14.7098C14.61 14.5198 14.5 14.2598 14.5 13.9998C14.5 13.7398 14.61 13.4798 14.79 13.2898C14.89 13.1998 14.99 13.1298 15.12 13.0798C15.3 12.9998 15.5 12.9798 15.7 13.0198C15.76 13.0298 15.82 13.0498 15.88 13.0798C15.94 13.0998 16 13.1298 16.06 13.1698C16.11 13.2098 16.16 13.2498 16.21 13.2898C16.39 13.4798 16.5 13.7398 16.5 13.9998C16.5 14.2598 16.39 14.5198 16.21 14.7098Z" fill="currentColor" />
        </svg>
    },
    {
        title: "Saved Addresses", path: "address", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 21.2502H21V9.98021C21 9.36021 20.72 8.78021 20.23 8.40021L19 7.44021L18.98 4.99021C18.98 4.44021 18.53 4.00021 17.98 4.00021H14.57L13.23 2.96021C12.51 2.39021 11.49 2.39021 10.77 2.96021L3.77 8.40021C3.28 8.78021 3 9.36021 3 9.97021L2.95 21.2502H2C1.59 21.2502 1.25 21.5902 1.25 22.0002C1.25 22.4102 1.59 22.7502 2 22.7502H22C22.41 22.7502 22.75 22.4102 22.75 22.0002C22.75 21.5902 22.41 21.2502 22 21.2502ZM6.5 12.7502V11.2502C6.5 10.7002 6.95 10.2502 7.5 10.2502H9.5C10.05 10.2502 10.5 10.7002 10.5 11.2502V12.7502C10.5 13.3002 10.05 13.7502 9.5 13.7502H7.5C6.95 13.7502 6.5 13.3002 6.5 12.7502ZM14.5 21.2502H9.5V18.5002C9.5 17.6702 10.17 17.0002 11 17.0002H13C13.83 17.0002 14.5 17.6702 14.5 18.5002V21.2502ZM17.5 12.7502C17.5 13.3002 17.05 13.7502 16.5 13.7502H14.5C13.95 13.7502 13.5 13.3002 13.5 12.7502V11.2502C13.5 10.7002 13.95 10.2502 14.5 10.2502H16.5C17.05 10.2502 17.5 10.7002 17.5 11.2502V12.7502Z" fill="currentColor" />
        </svg>
    },
    {
        title: "My Wallet", path: "/wallet", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.85 3.9498V7.7498H13.35V3.9498C13.35 3.6798 13.11 3.5498 12.95 3.5498C12.9 3.5498 12.85 3.5598 12.8 3.5798L4.87 6.56981C4.34 6.7698 4 7.2698 4 7.8398V8.5098C3.09 9.1898 2.5 10.2798 2.5 11.5098V7.8398C2.5 6.6498 3.23 5.5898 4.34 5.1698L12.28 2.1698C12.5 2.0898 12.73 2.0498 12.95 2.0498C13.95 2.0498 14.85 2.8598 14.85 3.9498Z" fill="currentColor" />
            <path d="M21.5002 14.5V15.5C21.5002 15.77 21.2902 15.99 21.0102 16H19.5502C19.0202 16 18.5402 15.61 18.5002 15.09C18.4702 14.78 18.5902 14.49 18.7902 14.29C18.9702 14.1 19.2202 14 19.4902 14H21.0002C21.2902 14.01 21.5002 14.23 21.5002 14.5Z" fill="currentColor" />
            <path d="M19.48 12.95H20.5C21.05 12.95 21.5 12.5 21.5 11.95V11.51C21.5 9.44 19.81 7.75 17.74 7.75H6.26C5.41 7.75 4.63 8.03 4 8.51C3.09 9.19 2.5 10.28 2.5 11.51V18.24C2.5 20.31 4.19 22 6.26 22H17.74C19.81 22 21.5 20.31 21.5 18.24V18.05C21.5 17.5 21.05 17.05 20.5 17.05H19.63C18.67 17.05 17.75 16.46 17.5 15.53C17.29 14.77 17.54 14.04 18.04 13.55C18.41 13.17 18.92 12.95 19.48 12.95ZM14 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H14C14.41 11.25 14.75 11.59 14.75 12C14.75 12.41 14.41 12.75 14 12.75Z" fill="currentColor" />
        </svg>
    },
    {
        title: "Refer & Earn", path: "/refer-earn", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 12V18C20 20.21 18.21 22 16 22H8C5.79 22 4 20.21 4 18V12C4 11.45 4.45 11 5 11H6.97C7.52 11 7.97 11.45 7.97 12V15.14C7.97 15.88 8.38 16.56 9.03 16.91C9.32 17.07 9.64 17.15 9.97 17.15C10.35 17.15 10.73 17.04 11.06 16.82L12.01 16.2L12.89 16.79C13.5 17.2 14.28 17.25 14.93 16.9C15.59 16.55 16 15.88 16 15.13V12C16 11.45 16.45 11 17 11H19C19.55 11 20 11.45 20 12Z" fill="currentColor" />
            <path d="M21.5 7V8C21.5 9.1 20.97 10 19.5 10H4.5C2.97 10 2.5 9.1 2.5 8V7C2.5 5.9 2.97 5 4.5 5H19.5C20.97 5 21.5 5.9 21.5 7Z" fill="currentColor" />
            <path d="M11.6398 4.99994H6.11978C5.77978 4.62994 5.78978 4.05994 6.14978 3.69994L7.56978 2.27994C7.93978 1.90994 8.54978 1.90994 8.91978 2.27994L11.6398 4.99994Z" fill="currentColor" />
            <path d="M17.8701 4.99994H12.3501L15.0701 2.27994C15.4401 1.90994 16.0501 1.90994 16.4201 2.27994L17.8401 3.69994C18.2001 4.05994 18.2101 4.62994 17.8701 4.99994Z" fill="currentColor" />
            <path d="M13.9699 11C14.5199 11 14.9699 11.45 14.9699 12V15.13C14.9699 15.93 14.0799 16.41 13.4199 15.96L12.5199 15.36C12.1899 15.14 11.7599 15.14 11.4199 15.36L10.4799 15.98C9.81994 16.42 8.93994 15.94 8.93994 15.15V12C8.93994 11.45 9.38994 11 9.93994 11H13.9699Z" fill="currentColor" />
        </svg>
    },
    {
        title: "Contact", path: "/contact", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.05 14.95L9.2 16.8C8.81 17.19 8.19 17.19 7.79 16.81C7.68 16.7 7.57 16.6 7.46 16.49C6.43 15.45 5.5 14.36 4.67 13.22C3.85 12.08 3.19 10.94 2.71 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C10.83 13.32 10.94 13.42 11.04 13.52C11.44 13.91 11.45 14.55 11.05 14.95Z" fill="currentColor" />
            <path d="M21.9701 18.33C21.9701 18.61 21.9201 18.9 21.8201 19.18C21.7901 19.26 21.7601 19.34 21.7201 19.42C21.5501 19.78 21.3301 20.12 21.0401 20.44C20.5501 20.98 20.0101 21.37 19.4001 21.62C19.3901 21.62 19.3801 21.63 19.3701 21.63C18.7801 21.87 18.1401 22 17.4501 22C16.4301 22 15.3401 21.76 14.1901 21.27C13.0401 20.78 11.8901 20.12 10.7501 19.29C10.3601 19 9.9701 18.71 9.6001 18.4L12.8701 15.13C13.1501 15.34 13.4001 15.5 13.6101 15.61C13.6601 15.63 13.7201 15.66 13.7901 15.69C13.8701 15.72 13.9501 15.73 14.0401 15.73C14.2101 15.73 14.3401 15.67 14.4501 15.56L15.2101 14.81C15.4601 14.56 15.7001 14.37 15.9301 14.25C16.1601 14.11 16.3901 14.04 16.6401 14.04C16.8301 14.04 17.0301 14.08 17.2501 14.17C17.4701 14.26 17.7001 14.39 17.9501 14.56L21.2601 16.91C21.5201 17.09 21.7001 17.3 21.8101 17.55C21.9101 17.8 21.9701 18.05 21.9701 18.33Z" fill="currentColor" />
        </svg>
    },
    {
        title: "About", path: "/about", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM11.25 8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75C11.59 13.75 11.25 13.41 11.25 13V8ZM12.92 16.38C12.87 16.51 12.8 16.61 12.71 16.71C12.61 16.8 12.5 16.87 12.38 16.92C12.26 16.97 12.13 17 12 17C11.87 17 11.74 16.97 11.62 16.92C11.5 16.87 11.39 16.8 11.29 16.71C11.2 16.61 11.13 16.51 11.08 16.38C11.03 16.26 11 16.13 11 16C11 15.87 11.03 15.74 11.08 15.62C11.13 15.5 11.2 15.39 11.29 15.29C11.39 15.2 11.5 15.13 11.62 15.08C11.86 14.98 12.14 14.98 12.38 15.08C12.5 15.13 12.61 15.2 12.71 15.29C12.8 15.39 12.87 15.5 12.92 15.62C12.97 15.74 13 15.87 13 16C13 16.13 12.97 16.26 12.92 16.38Z" fill="currentColor" />
        </svg>
    },
    {
        title: "Language", path: "Language", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.93 2H5.02C3 2 2 3 2 5.02V8.94C2 11 3 12 5.02 11.95H8.94C11 12 12 11 11.95 8.93V5.02C12 3 11 2 8.93 2ZM9.01 9.76C8.33 9.76 7.67 9.5 7.12 9.04C6.5 9.49 5.75 9.76 4.94 9.76C4.53 9.76 4.19 9.42 4.19 9.01C4.19 8.6 4.53 8.26 4.94 8.26C5.96 8.26 6.81 7.56 7.12 6.6H4.94C4.53 6.6 4.19 6.26 4.19 5.85C4.19 5.44 4.53 5.1 4.94 5.1H6.23C6.27 4.72 6.58 4.42 6.97 4.42C7.36 4.42 7.67 4.72 7.71 5.1H7.97C7.98 5.1 7.99 5.1 7.99 5.1H8.01H9C9.41 5.1 9.75 5.44 9.75 5.85C9.75 6.26 9.42 6.6 9 6.6H8.67C8.58 7.08 8.39 7.53 8.14 7.94C8.41 8.14 8.7 8.26 9.01 8.26C9.42 8.26 9.76 8.6 9.76 9.01C9.76 9.42 9.42 9.76 9.01 9.76Z" fill="currentColor" />
            <path d="M9 22.75C4.73 22.75 1.25 19.27 1.25 15C1.25 14.59 1.59 14.25 2 14.25C2.41 14.25 2.75 14.59 2.75 15C2.75 17.96 4.81 20.44 7.58 21.09L7.31 20.64C7.1 20.28 7.21 19.82 7.57 19.61C7.92 19.4 8.39 19.51 8.6 19.87L9.65 21.62C9.79 21.85 9.79 22.14 9.66 22.37C9.52 22.6 9.27 22.75 9 22.75Z" fill="currentColor" />
            <path d="M21.9999 9.75C21.5899 9.75 21.2499 9.41 21.2499 9C21.2499 6.04 19.1899 3.56 16.4199 2.91L16.6899 3.36C16.8999 3.72 16.7899 4.18 16.4299 4.39C16.0799 4.6 15.6099 4.49 15.3999 4.13L14.3499 2.38C14.2099 2.15 14.2099 1.86 14.3399 1.63C14.4799 1.4 14.7299 1.25 14.9999 1.25C19.2699 1.25 22.7499 4.73 22.7499 9C22.7499 9.41 22.4099 9.75 21.9999 9.75Z" fill="currentColor" />
            <path d="M16.9198 11.8501C14.1198 11.8501 11.8398 14.1201 11.8398 16.9301C11.8398 19.7301 14.1098 22.0101 16.9198 22.0101C19.7198 22.0101 21.9998 19.7401 21.9998 16.9301C21.9998 14.1201 19.7298 11.8501 16.9198 11.8501ZM19.3998 19.3401C19.0298 19.5201 18.5798 19.3801 18.3898 19.0001L18.2198 18.6601H15.6298L15.4598 19.0001C15.3298 19.2601 15.0598 19.4101 14.7898 19.4101C14.6798 19.4101 14.5598 19.3801 14.4598 19.3301C14.0898 19.1401 13.9398 18.6901 14.1198 18.3201L16.2598 14.0501C16.3898 13.8001 16.6498 13.6401 16.9298 13.6401C17.2098 13.6401 17.4698 13.8001 17.5998 14.0601L19.7398 18.3301C19.9198 18.7001 19.7698 19.1501 19.3998 19.3401Z" fill="currentColor" />
            <path d="M16.3799 17.1598H17.4699L16.9199 16.0698L16.3799 17.1598Z" fill="currentColor" />
        </svg>
    },
    {
        title: "Privacy Policy", path: "/privacy-policy", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.0001 17.3498C12.9003 17.3498 13.6301 16.6201 13.6301 15.7198C13.6301 14.8196 12.9003 14.0898 12.0001 14.0898C11.0999 14.0898 10.3701 14.8196 10.3701 15.7198C10.3701 16.6201 11.0999 17.3498 12.0001 17.3498Z" fill="currentColor" />
            <path d="M18.28 9.53V8.28C18.28 5.58 17.63 2 12 2C6.37 2 5.72 5.58 5.72 8.28V9.53C2.92 9.88 2 11.3 2 14.79V16.65C2 20.75 3.25 22 7.35 22H16.65C20.75 22 22 20.75 22 16.65V14.79C22 11.3 21.08 9.88 18.28 9.53ZM12 18.74C10.33 18.74 8.98 17.38 8.98 15.72C8.98 14.05 10.34 12.7 12 12.7C13.66 12.7 15.02 14.06 15.02 15.72C15.02 17.39 13.67 18.74 12 18.74ZM7.35 9.44C7.27 9.44 7.2 9.44 7.12 9.44V8.28C7.12 5.35 7.95 3.4 12 3.4C16.05 3.4 16.88 5.35 16.88 8.28V9.45C16.8 9.45 16.73 9.45 16.65 9.45H7.35V9.44Z" fill="currentColor" />
        </svg>
    },
    {
        title: "Terms & Condition", path: "/terms-condition", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.99855 2.01416C6.43754 2.01416 2.99854 5.41996 2.99854 8.98296C2.99854 8.99326 2.99854 9.00376 2.99854 9.01416C2.99854 11.4742 2.99854 14.4105 2.99854 14.6704C2.99854 16.5342 4.60955 18.0142 6.56055 18.0142H6.99854V18.6704C6.99854 20.5342 8.60956 22.0142 10.5606 22.0142H17.4365C19.3876 22.0142 20.9986 20.5342 20.9986 18.6704V9.35796C20.9986 7.49416 19.3876 6.01416 17.4365 6.01416H16.9986V5.35796C16.9986 3.49416 15.3875 2.01416 13.4365 2.01416C13.2225 2.01416 13.2126 2.01416 9.99855 2.01416ZM8.99855 4.26416V6.67036C8.99855 7.38396 8.32453 8.01416 7.43653 8.01416H5.21753C5.67653 6.24696 7.22654 4.73456 8.99855 4.26416ZM16.9986 8.01416H17.4365C18.3245 8.01416 18.9986 8.64436 18.9986 9.35796V18.6704C18.9986 19.384 18.3245 20.0142 17.4365 20.0142H10.5606C9.67256 20.0142 8.99855 19.384 8.99855 18.6704V18.0142H13.4365C15.3875 18.0142 16.9986 16.5342 16.9986 14.6704V8.01416Z" fill="currentColor" />
        </svg>
    },
    {
        title: "Logout", path: "Logout", icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.8 2H14.2C11 2 9 4 9 7.2V11.25H15.25C15.66 11.25 16 11.59 16 12C16 12.41 15.66 12.75 15.25 12.75H9V16.8C9 20 11 22 14.2 22H16.79C19.99 22 21.99 20 21.99 16.8V7.2C22 4 20 2 16.8 2Z" fill="#080B30" />
            <path d="M4.55994 11.2498L6.62994 9.17984C6.77994 9.02984 6.84994 8.83984 6.84994 8.64984C6.84994 8.45984 6.77994 8.25984 6.62994 8.11984C6.33994 7.82984 5.85994 7.82984 5.56994 8.11984L2.21994 11.4698C1.92994 11.7598 1.92994 12.2398 2.21994 12.5298L5.56994 15.8798C5.85994 16.1698 6.33994 16.1698 6.62994 15.8798C6.91994 15.5898 6.91994 15.1098 6.62994 14.8198L4.55994 12.7498H8.99994V11.2498H4.55994Z" fill="currentColor" />
        </svg>
    }];

    const LanguageList = [
        { id: "en", title: "Engliash" },
        { id: "ar", title: "عربي" },
        { id: "hi", title: "hindi" },
        { id: "sp", title: "Spanish" },
        { id: "fr", title: "French" },
        { id: "ge", title: "Germany" },
        { id: "in", title: "Indonesia" },
        { id: "sa", title: "South Africa" },
        { id: "tu", title: "Turkish" },
        { id: "po", title: "Portuguese" },
    ];

    const [loading, setLoading] = useState(true);
    const [address, setAddress] = useState("");
    const [issearch, setIsSearch] = useState(false);
    const [islanguage, setIsLanguage] = useState(false);
    const [selectlang, setSelectLang] = useState("en");
    const [locationerror, setLocationError] = useState(false);
    const [isshow, setIsShow] = useState(false);
    const [coords, setCoords] = useState({ lat: "", long: "" });
    const [inputsearch, setInputSearch] = useState("");
    const [addreslist, setAddresList] = useState([]);
    const [apiloading, setApiloading] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    const navigate = useNavigate();
    const SearchRef = useRef();
    const initialized = useRef(false);

    const Userid = secureLocalStorage.getItem("Userid");
    const LoginData = secureLocalStorage.getItem("Logindata");

    if (LoginData) {
        var { name } = JSON.parse(LoginData);
    }

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const lat = position.coords.latitude;
                    const long = position.coords.longitude;
                    setCoords({ lat, long });
                    const Location = secureLocalStorage.getItem("selectlocation");
                    if (Location) {
                        const { formatted_address } = JSON.parse(Location);
                        setAddress(formatted_address);
                    } else {
                        HandleGetGoogleAddress(lat, long, 0);
                    }
                },
                error => {
                    setLocationError(true);
                }
            );
        } else {
            setLocationError(true);
        }
        setSelectLang(secureLocalStorage.getItem("I18") || "en");
    }, [MapKey]);

    useEffect(() => {
        document.body.style.overflow = isshow ? "hidden" : "auto";
    }, [isshow]);

    useEffect(() => {
        if (inputsearch) {
            setApiloading(true);
            axios.get(`${BaseUrl}user_api/mapresponse?query=${inputsearch}`)
                .then((res) => {
                    setAddresList(res.data.results);
                    setApiloading(false);
                })
                .catch((error) => {
                    console.error("Location Search Data :-->>", error);
                });
        }
    }, [inputsearch]);

    useEffect(() => {
        const isShowStored = secureLocalStorage.getItem("pwa");

        const shouldShowInstall = isShowStored !== null ? isShowStored : true;
        setIsInstallable(shouldShowInstall);

        if (!shouldShowInstall) return;

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    useEffect(() => {
        const TimeOut = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(TimeOut);
    }, []);

    useEffect(() => {
        handleOneSignal();
    }, [islogin])

    useEffect(() => {
        document.body.style.overflow = loading ? "hidden" : "auto";
    }, [loading])

    const handleSelectAddress = (item, index) => {

        const lat = item?.geometry?.location.lat || item.lat;
        const long = item?.geometry?.location.lng || item.long;

        const Coordinates = secureLocalStorage.getItem("coordinates");

        const Location = {
            lat, long,
            formatted_address: item.formatted_address,
            name: item.name
        }

        if (Coordinates && index === 0) {
            const zones = JSON.parse(Coordinates);

            const userPoint = turf.point([long, lat]);

            let isInsideAnyZone = false;
            let matchedZone = null;

            for (const zone of zones) {
                const coords = zone.coordinates.map(p => [p.lng, p.lat]);
                const polygon = turf.polygon([coords]);
                const inside = turf.booleanPointInPolygon(userPoint, polygon);
                if (inside) {
                    isInsideAnyZone = true;
                    matchedZone = zone;
                    break;
                }
            }

            if (!isInsideAnyZone) {
                showToast({
                    title: t("We currently do not provide service in your selected area."),
                    id: "info",
                });
                return;
            }
        }

        setAddress(item.formatted_address);
        secureLocalStorage.setItem("selectlocation", JSON.stringify(Location));
        setIsShow(false);
        setIsChangeLocation(prev => prev + 1);
        secureLocalStorage.removeItem("Productid");
        setInputSearch("");
        setAddresList([]);
        navigate("/");
    }

    const HandleGetGoogleAddress = async (lat, long, index) => {
        try {

            const Coordinates = secureLocalStorage.getItem("coordinates");

            if (Coordinates) {
                const zones = JSON.parse(Coordinates);
                const userPoint = turf.point([long, lat]);
                let isInsideAnyZone = false;
                let matchedZone = null;

                for (const zone of zones) {
                    const coords = zone.coordinates.map(p => [p.lng, p.lat]);
                    const polygon = turf.polygon([coords]);
                    const inside = turf.booleanPointInPolygon(userPoint, polygon);
                    if (inside) {
                        isInsideAnyZone = true;
                        matchedZone = zone;
                        break;
                    }
                }
            }

            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${MapKey}`
            );

            const address = response.data.results[0]?.address_components;

            if (address) {

                const getComponent = (type) => {
                    const comp = address.find(c => c.types.includes(type));
                    return comp?.long_name || '';
                };

                const thoroughfare = getComponent('route');
                const subLocality = getComponent('sublocality');
                const locality = getComponent('locality');
                const subAdminArea = getComponent('administrative_area_level_2');
                const postalCode = getComponent('postal_code');
                const adminArea = getComponent('administrative_area_level_1');

                const fulladdress =
                    `${thoroughfare ? thoroughfare + ', ' : ''}` +
                    `${subLocality ? subLocality + ', ' : ''}` +
                    `${locality ? locality + ', ' : ''}` +
                    `${subAdminArea ? subAdminArea + ', ' : ''}` +
                    `${postalCode ? postalCode + ', ' : ''}` +
                    `${adminArea || ''}`;

                setAddress(fulladdress);
                setIsShow(false);

                if (index === 1) {
                    secureLocalStorage.removeItem("selectlocation");
                    setIsChangeLocation(prev => prev + 1);
                    setInputSearch("");
                    setAddresList([]);
                    navigate("/");
                }

            } else {
                console.warn('No address found for this location.');
            }
        } catch (error) {
            console.error('Error fetching address:', error);
        }
    }

    const handleNavigate = (path) => {
        if (path === "address") {
            setIsShowAdsBox(true);
            setTimeout(() => {
                AddressRef.current.classList.add('addres_menu_open');
            }, 100);
            return;
        }

        if (path === "Logout") {
            showToast({ title: t('Logout Successfully !!'), id: "success" });
            secureLocalStorage.clear();
            sessionStorage.clear();
            navigate("/");
            return;
        }

        if (path === "Language") {
            setIsLanguage(true);
            return;
        }

        navigate(path);
    }

    const handleOpenClose = (index) => {
        if (index === 1) {
            if (!Userid) {
                navigate("/login");
                return;
            }
        } else if (index === 3) {
            AddressRef.current.classList.remove('addres_menu_open');
            setTimeout(() => {
                setIsShowAdsBox(false);
            }, 500);
        } else if (index === 4) {
            setIsSearch(true);
            setTimeout(() => {
                SearchRef.current.classList.add("addres_menu_open");
            }, 100);
        } else {
            SearchRef.current.classList.remove('addres_menu_open');
            setTimeout(() => {
                setIsSearch(false);
            }, 500);
        }

    }

    const handleSelectLanguage = (id) => {
        setSelectLang(id);
        i18n.changeLanguage(id);
        secureLocalStorage.setItem("I18", id);
        setIsLanguage(false);
    }

    const HandleLocationEnable = () => {
        showToast({ title: "You have blocked Fixora from tracking your location. To use this, change your location settings in browser.", id: "info" });
    }

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === "accepted") {
                secureLocalStorage.setItem("pwa", false);
                setDeferredPrompt(null);
                setIsInstallable(false);
            }
        }
    };

    const handleClosePwaCard = () => {
        setIsInstallable(false);
        secureLocalStorage.setItem("pwa", false);
    }

    const handleOneSignal = async () => {
        if (Userid && !initialized.current) {
            OneSignal.init({
                appId: oneSignalAppId,
                safari_web_id: "web.onesignal.auto.xxx",
                notifyButton: {
                    enable: true,
                },
                serviceWorkerParam: { scope: "/" },
                serviceWorkerPath: "OneSignalSDKWorker.js",
                allowLocalhostAsSecureOrigin: true,
            }).then(async () => {

                OneSignal.User.addTags({
                    "userid": Userid,
                });

                initialized.current = true;

            }).catch((error) => {
                // console.error("OneSignal initialization error:", error);
            });
        }
    };

    if (loading) {
        return (<div className="w-full h-[100vh] bg-white z-[777] fixed flex items-center justify-center">
            <div className="loader"></div>
        </div>)
    }

    return (
        <div className="header_page">

            <div className="header_box">
                <div className="width_container">

                    <div className="flex items-center justify-between">
                        <div className="left_box">
                            <Link to="/"><img src={Logo} className="w-[55px]" alt="Logo" /></Link>
                            <div onClick={() => setIsShow(true)} className="flex items-center gap-[5px] w-full overflow-hidden max-_770_:hidden cursor-pointer">
                                <svg width="30" height="30" className="max-w-[20px] min-w-[20px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2.25C7.175 2.25 3.25 6.175 3.25 11C3.25 16.118 7.94699 19.2199 11.055 21.2729L11.584 21.624C11.71 21.708 11.855 21.75 12 21.75C12.145 21.75 12.29 21.708 12.416 21.624L12.945 21.2729C16.053 19.2199 20.75 16.118 20.75 11C20.75 6.175 16.825 2.25 12 2.25ZM12.119 20.021L12 20.1001L11.881 20.021C8.871 18.033 4.75 15.311 4.75 11C4.75 7.002 8.002 3.75 12 3.75C15.998 3.75 19.25 7.002 19.25 11C19.25 15.311 15.128 18.034 12.119 20.021ZM12 7.75C10.208 7.75 8.75 9.208 8.75 11C8.75 12.792 10.208 14.25 12 14.25C13.792 14.25 15.25 12.792 15.25 11C15.25 9.208 13.792 7.75 12 7.75ZM12 12.75C11.035 12.75 10.25 11.965 10.25 11C10.25 10.035 11.035 9.25 12 9.25C12.965 9.25 13.75 10.035 13.75 11C13.75 11.965 12.965 12.75 12 12.75Z" fill="white" />
                                </svg>
                                <p className="whitespace-nowrap overflow-hidden overflow-ellipsis text-[14px]">{address}</p>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 16.75C11.808 16.75 11.616 16.6771 11.47 16.5301L4.46999 9.53005C4.17699 9.23705 4.17699 8.76202 4.46999 8.46902C4.76299 8.17602 5.23803 8.17602 5.53103 8.46902L12.001 14.939L18.471 8.46902C18.764 8.17602 19.239 8.17602 19.532 8.46902C19.825 8.76202 19.825 9.23705 19.532 9.53005L12.532 16.5301C12.384 16.6771 12.192 16.75 12 16.75Z" fill="white" />
                                </svg>
                            </div>
                        </div>

                        <div className="right_box">
                            <div className="flex items-center gap-[15px]">
                                <div onClick={() => handleOpenClose(4)} className="flex items-center gap-[5px] cursor-text">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="white"></path>
                                    </svg>
                                    <h1 className='-ms-[25px] px-[25px] max-_1210_:hidden border-b-[1px] border-white whitespace-nowrap'>{t("Search for service...")}</h1>
                                </div>
                                {secureLocalStorage.getItem("showhire") == "1" && <Link to="/hire" state={catlist} className='text-[15px] whitespace-nowrap font-medium border px-[10px] py-[3px] rounded-[10px] hover:bg-white hover:text-black duration-300'>{t("Hire Partner")}</Link>}
                                {!Userid
                                    ? <Link to="/login">
                                        <img className="w-[45px] h-[45px] object-cover rounded-[100%] cursor-pointer" alt="Login Icon" src="https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png"></img>
                                    </Link>
                                    : <div className="user_dropdown_wrapper">

                                        <div className="w-[45px] h-[45px] rounded-full flex items-center justify-center bg-gray-200 cursor-pointer">
                                            <h1 className="text-black font-bold text-[22px]">{String(name.slice(0, 1)).toUpperCase()}</h1>
                                        </div>

                                        <div className="dropdown_box">
                                            <ul className="dropdown_menu">
                                                {MenuList.map((item, index) => {
                                                    return <li key={index} onClick={() => handleNavigate(item.path)} className="flex items-center gap-[5px] cursor-pointer py-[5px]">
                                                        <div className="text-black">{item.icon}</div>
                                                        <h1 className="h1"> {t(item.title)}</h1>
                                                    </li>
                                                })}
                                            </ul>
                                        </div>
                                    </div>}
                            </div>
                        </div>

                    </div>

                </div>

                <div className={`pwa_card ${isInstallable ? "translate-y-0" : "-translate-y-[150%]"}`}>
                    <div className="-translate-x-[50%] bg-white p-[20px] rounded-[12px]">
                        <div className="flex items-start justify-between">
                            <div className="flex items-center gap-[15px] pb-[10px]">
                                <img src={FooterLogo} className='w-[60px]' alt="logo" />
                                <div className="">
                                    <h1 className='font-[500] text-[17px] text-gray-700'>Fixora</h1>
                                    <p className='text-[14px] text-gray-500'>{BaseUrl}</p>
                                </div>
                            </div>
                            <button onClick={handleClosePwaCard}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                                </svg>
                            </button>
                        </div>
                        <h1 className='text-[15px] my-[5px] font-[500] text-gray-700'>Install Progressive Web Application</h1>
                        <p className='text-[14px] text-gray-500'>This site has app functionality. Install it on your device for extensive experience and easy access.</p>

                        <div className="w-full flex justify-end mt-[10px]">
                            <button onClick={handleInstallClick} className='font-[500] border-[1px] border-[black] text-black hover:bg-[#000000c4] duration-[.30s] hover:text-white px-[20px] py-[5px] rounded-[10px]'>Install</button>
                        </div>
                    </div>
                </div>
            </div>


            {isshowadsbox && <div ref={AddressRef} className={`addres_menu`}>
                <SavAddress />
            </div>}

            {issearch && <div ref={SearchRef} className={`addres_menu`}>
                <Search SearchRef={SearchRef} setIsSearch={setIsSearch} />
            </div>}

            {islanguage && <div onClick={() => setIsLanguage(false)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="w-[450px] bg-white p-[20px] rounded-[10px]">
                    {LanguageList.map((item, index) => {
                        const IsSelected = item.id === selectlang;
                        return <div key={index} onClick={() => handleSelectLanguage(item.id)} className="language_box">
                            <h1 className='font-[600]'>{item.title}</h1>
                            <div className="w-[18px] h-[18px] border-[2px] border-gray-300 rounded-full p-[2px]">
                                <div className={`w-full h-full rounded-full duration-[.5s] ${IsSelected ? "bg-black" : "bg-transparent"}`}></div>
                            </div>
                        </div>
                    })}
                </div>
            </div>}

            {locationerror && (<div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                    <div className="text-black">
                        <h2 className="m-0 text-center font-[500] text-[17px]">{t("Enable Location Services")}</h2>
                        <img src={LocationImg} alt="location-img" />
                        <div className="my-3">
                            <div className="flex gap-[10px]">
                                <span className="text-[18px]">1.</span>
                                <h6>{t("To provide accurate services, please enable your location.")}</h6>
                            </div>
                            <div className="flex gap-[5px]">
                                <span className="text-[18px]">2.</span>
                                <h6>{t("Allow location access when prompted. If not prompted, enable it in your browser settings.")}</h6>
                            </div>
                            <h6>{t("🔄 Refresh the page after enabling.")}</h6>
                        </div>
                        <button onClick={HandleLocationEnable} className="bg-[--bgcolor] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Enable Now")}</button>
                    </div>
                </div>
            </div>)}

            {isshow && <div onClick={() => setIsShow(false)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="search_location">

                    <button onClick={() => { setIsShow(false); setAddresList([]); }} className="close_btn">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="black" />
                        </svg>
                    </button>

                    <div>
                        <div className="px-[20px] pt-[20px] pb-[15px]">
                            <div className="border-[1px] rounded-[8px] px-[10px]">
                                <div className="flex items-center">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#545454" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M10.875 2a8.875 8.875 0 105.528 15.818l3.89 3.89 1.414-1.415-3.89-3.889A8.875 8.875 0 0010.875 2zM4 10.875a6.875 6.875 0 1113.75 0 6.875 6.875 0 01-13.75 0z" fill="black"></path>
                                    </svg>
                                    <input type="text" value={inputsearch} onChange={(e) => setInputSearch(e.target.value)} className="w-full outline-none py-[8px] px-[10px]" placeholder={t("Search for your location/society/apartment")} />
                                    {apiloading
                                        && <div className="w-[25px]">
                                            <div className="location_loader"></div>
                                        </div>}
                                </div>
                            </div>
                            <button onClick={() => HandleGetGoogleAddress(coords.lat, coords.long, 1)} className="flex justify-center gap-[10px] items-center mt-[10px] text-[--color]">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 8.75C10.208 8.75 8.75 10.208 8.75 12C8.75 13.792 10.208 15.25 12 15.25C13.792 15.25 15.25 13.792 15.25 12C15.25 10.208 13.792 8.75 12 8.75ZM12 13.75C11.035 13.75 10.25 12.965 10.25 12C10.25 11.035 11.035 10.25 12 10.25C12.965 10.25 13.75 11.035 13.75 12C13.75 12.965 12.965 13.75 12 13.75ZM21 11.25H19.712C19.357 7.574 16.426 4.64309 12.75 4.28809V3C12.75 2.586 12.414 2.25 12 2.25C11.586 2.25 11.25 2.586 11.25 3V4.28809C7.574 4.64309 4.64302 7.574 4.28802 11.25H3C2.586 11.25 2.25 11.586 2.25 12C2.25 12.414 2.586 12.75 3 12.75H4.28802C4.64302 16.426 7.574 19.3569 11.25 19.7119V21C11.25 21.414 11.586 21.75 12 21.75C12.414 21.75 12.75 21.414 12.75 21V19.7119C16.426 19.3569 19.357 16.426 19.712 12.75H21C21.414 12.75 21.75 12.414 21.75 12C21.75 11.586 21.414 11.25 21 11.25ZM12 18.25C8.554 18.25 5.75 15.446 5.75 12C5.75 8.554 8.554 5.75 12 5.75C15.446 5.75 18.25 8.554 18.25 12C18.25 15.446 15.446 18.25 12 18.25Z" fill="currentColor" />
                                </svg>
                                <h1 className="font-[600]">{t("Use current location")}</h1>
                            </button>
                        </div>
                    </div>

                    {addreslist.length >= 1 && <div className="scroll_container h-full">
                        <div className="bg-[#f5f5f5] w-full h-[10px]"></div>
                        <div className="px-[20px] scroll_container">
                            {addreslist?.map((item, index) => {
                                return <div key={index} onClick={() => handleSelectAddress(item, 0)} className={`address_box ${index !== 0 ? "border-t-[1px] border-[--bordercolor]" : ""}`}>
                                    <svg width="25" height="25" viewBox="0 0 24 24" fill="#545454" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.426 22.569L12 21.75l.573.82a1 1 0 01-1.147-.001z" fill="#545454"></path>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 5.75a4 4 0 100 8 4 4 0 000-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z" fill="#545454"></path>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.426 22.569L12 21.75c.573.82.575.818.575.818l.002-.001.006-.004.02-.015.07-.05.257-.192a25.395 25.395 0 003.575-3.368c1.932-2.223 3.995-5.453 3.995-9.188a8.5 8.5 0 10-17 0c0 3.735 2.063 6.965 3.995 9.187a25.4 25.4 0 003.575 3.369 14.361 14.361 0 00.327.242l.02.015.006.004.003.002zM7.404 5.154A6.5 6.5 0 0118.5 9.75c0 3.015-1.687 5.785-3.505 7.875A23.403 23.403 0 0112 20.495a23.4 23.4 0 01-2.995-2.869C7.187 15.534 5.5 12.764 5.5 9.75a6.5 6.5 0 011.904-4.596z" fill="#545454"></path>
                                    </svg>
                                    <div className="w-full overflow-hidden leading-5">
                                        <h1 className="font-[600] text-[rgb(15,15,15)] whitespace-nowrap overflow-ellipsis overflow-hidden">{item.name}</h1>
                                        <p className="text-[rgb(84,84,84)] text-[14px] whitespace-nowrap overflow-ellipsis overflow-hidden">{item.formatted_address}</p>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>}


                </div>
            </div>}

            {isshowadsbox && <div onClick={() => handleOpenClose(3)} className="overlay"></div>}
            {issearch && <div onClick={() => handleOpenClose(5)} className="overlay"></div>}

        </div>
    )
}

export default Header
/* jshint ignore:end */